import { gql } from "@apollo/client";

export const GET_VENDORS = gql`
  query GetVendors {
    vendors {
      _id
      id
      name
    }
  }
`;

export const GET_UPDATED_RS_VENDORS_QUERY = gql`
  query GetUpdatedRSVendors {
    fetchRSVendors {
      _id
      id
      name
    }
  }
`;
